
export default
{
    path: "invest",
    meta: {
        title: "投资报表"
    },
    component: () => import("@/layouts/item"),
    children: [
        {
            path: "invest-list",
            component: () => import("@/pages/statistic/invest/invest-list"),
            meta: {
                title: "投资列表"
            }
        },
        {
            path: "invest-analysis",
            component: () => import("@/pages/statistic/invest/invest-analysis"),
            meta: {
                title: "投资分析"
            }
        },


    ]
}

